import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { newsletterApi, type StatsPeriod } from "../api/newsletterApi";
import type { PaginationParams } from "../types";

export const newsletterKeys = {
  all: ["newsletter"] as const,
  subscriptions: (params?: PaginationParams) =>
    [...newsletterKeys.all, "subscriptions", params] as const,
  stats: (period?: StatsPeriod) => [...newsletterKeys.all, "stats", period] as const,
};

export const useNewsletterSubscriptions = (params?: PaginationParams) =>
  useQuery({
    queryKey: newsletterKeys.subscriptions(params),
    queryFn: () => newsletterApi.getSubscriptions(params),
  });

export const useNewsletterStats = (period?: StatsPeriod) =>
  useQuery({
    queryKey: newsletterKeys.stats(period),
    queryFn: () => newsletterApi.getStats(period),
    refetchInterval: 60_000,
  });

export const useAddSubscription = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (email: string) => newsletterApi.addSubscription(email),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: newsletterKeys.all });
    },
  });
};

export const useDeleteSubscription = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => newsletterApi.deleteSubscription(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: newsletterKeys.all });
    },
  });
};
